let config = require('./config')
let utils = require('@common/utils')
let request = require('@common/request')
require('@common/old.api')
let mask = require('../../modules/mask/index')

_qblog.setting({key: 20007, tcss: true});
_qblog.wsd.click("TRANSLATESYNCSPREAD.PV");

//AMS新集成
//zHttp.baseUrl = "//iyouxi3.vip.qq.com/ams3.0.php";
//活动地址 不带任何参数
var _pageUrl = location.protocol + '//' + location.host + location.pathname;
//main
/*let Page = qv.zero.extend(qv.zero.AbstractPage, {
  // 项目ID
  userJsonID: 290247,
  loadExtHandler: true,
  init: function () {
    Page.superclass.init.apply(this, arguments);

  },
  initEvent: function () {
    Page.superclass.initEvent.apply(this, arguments);
    $('body').on('click', 'a[href="#"]', function (e) {
      e.preventDefault();
    });
    qq.login.bind('login', function () {

    });
    qq.login.bind('logout', function () {

    });
    if (qq.login.getUin()) {

    }else{

    }

  },

})
window.page = new Page()*/



// WEBPACK FOOTER //
// ./pages/index/index.js